import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Chat from './Chat';
import Crm from './Crm';
import Home from './Home';
import Shop from './Shop';
import Csstmr from './Csstmr';
import Debate from './Debate';
import Rag from './Rag';
import ConveMain     from './ConveMain';
import ConveLogin    from './ConveLogin';
import ConveRegister from './ConveRegister';
import './App.css';

function AppRoutes() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [showSplash, setShowSplash] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const isConve = location.pathname.startsWith('/conve');

  useEffect(() => {
    const timer = setTimeout(() => setFadeOut(true), 1000);
    const hideTimer = setTimeout(() => setShowSplash(false), 1600);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);

  let splashTitle: React.ReactNode = '';
  switch (location.pathname) {
    case '/debate':
      splashTitle = 'AI 끝장토론';
      break;
    case '/crm':
      splashTitle = '일반기업용 AI';
      break;
    case '/chat':
      splashTitle = '🌿 ChatKooPT';
      break;
    case '/csmtr':
      splashTitle = 'ShopingMall 고객';
      break;
    case '/shop':
      splashTitle = 'ShopingMall 관리자';
      break;
    default:
      splashTitle = (
        <>
          <div className="splash-main">OASIS AI</div>
          <div className="splash-sub">Enterprise AI Platform</div>
        </>
      );
      break;
  }

  return (
    <div className={`app-wrapper ${isHome ? "scrollable" : ""} ${isConve ? "conve-wrap" : ""}`}>
      {/* Routes는 항상 렌더링 - 스플래시 뒤에서 미리 준비 */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/crm" element={<Crm />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/cstmr" element={<Csstmr />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/debate" element={<Debate />} />
        <Route path="/rag" element={<Rag />} />
        <Route path="/conve"              element={<ConveMain />} />
        <Route path="/conve/chat/:roomId" element={<ConveMain />} />
        <Route path="/conve/login"        element={<ConveLogin />} />
        <Route path="/conve/register"     element={<ConveRegister />} />
      </Routes>

      {/* 스플래시는 absolute overlay로 위에 덮음 */}
      {showSplash && !isConve && (
        <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
          <div className="splash-logo">{splashTitle}</div>
        </div>
      )}
    </div>
  );
}

export default AppRoutes;